export enum BillingAddressType {
  NEW_BILLING_ADDRESS = 'NEW_BILLING_ADDRESS',
  SAVED_BILLING_ADDRESS = 'SAVED_BILLING_ADDRESS'
}
